module.exports = __webpack_public_path__ + "img/18.4.NH3-N.8e325a19.png";